export default __webpack_public_path__ + "static/media/Bethel_logo.856c0d7e.svg";